import { Calculator, FileSpreadsheet, FolderSearch, Hourglass, MapPinOff, Repeat } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const PROBLEM_ICONS = {
  'Paper and Spreadsheet Timesheets': FileSpreadsheet,
  'Disconnected Workforce Records': FolderSearch,
  'Unclear Labour Costs': Calculator,
  'Limited Site Visibility': MapPinOff,
  'Late Profitability Information': Hourglass,
  'Excessive Administration': Repeat,
};

// Section 2 — the operational problem. Amber line icons, no emoji.
export const PulseProblem = ({ sp }) => (
  <section aria-labelledby="pulse-problem-heading" data-testid="pulse-problem" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="02"
        eyebrow="The Challenge"
        title="Workforce information should not be scattered across paper, spreadsheets and separate systems"
        description={sp.problemCopy}
        testid="pulse-problem-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.problems || []).map((problem, i) => {
          const Icon = PROBLEM_ICONS[problem.title] || FileSpreadsheet;
          return (
            <Reveal key={problem.title} delay={i * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`pulse-problem-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-gold-200 bg-gold-50 text-gold-700">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{problem.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{problem.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
